import {SLIDE} from './actions';

const DefaultState = {
  percent: 50
}

const pointSizeSlider = (state = DefaultState, action) => {
  switch (action.type) {
    case SLIDE:

      return Object.assign({}, {percent: action.size});

    default:
      return state;
  }
}

export {pointSizeSlider}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/pointSizeSlider/reducer.js